// extracted by mini-css-extract-plugin
module.exports = {"event":"RandomEvent_event__2jdhI","button":"RandomEvent_button__buY6m"};